<template>
  <div>
    <b-container>
      <div class="mt-4 mb-4 d-flex align-items-center justify-content-between">
        <div class="burger-spacing">
          <h1 class="page-title">{{$t('Users')}}</h1>
          <h2 class="page-subtitle mb-0">{{$t('Total')}} : {{ totalCount }}</h2>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn" v-if="allowCreate">
          {{$t('Add')}} {{$t('a')}} {{$t('user')}}
        </b-button>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableUser"
          identifier="B122TableUser"
          init-b122-table-url="/user/initB122Table"
          get-b122-table-results-url="/user/getB122TableResults"
          :fields="tableFields"
          :editItem=allowEdit
          :deleteItem=allowDelete
          :empty-title="$t('user.emptyTitle').toString()"
          :empty-text="$t('user.emptyText').toString()"
          @setTotalCount="setTotalCount"
          @clickOnShowBtn="clickOnShowBtn">

          <template #cell(actions)="row">
            <div class="actions-container text-right">
              <button class="action-btn edit mr-1" @click="clickOnEditBtn(row)">
                <pencil-icon size="18"/>
              </button>
              <button class="action-btn delete" @click="clickOnDeleteBtn(row)" v-if="row.item.role !== 'ROLE_SUPER_ADMIN'" :title="$t('Delete')">
                <trash-icon size="18"/>
              </button>
            </div>
          </template>

        </b122-table>
      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <Item-delete-modal
      itemSingularName="user"
      :beginsWithVoyel="true"
      :selectedItem="ui.selectedUser"
      :selectedItemSpecialString="ui.selectedUser ? ui.selectedUser.username : null"
      controllerName="user"
      itemSingularNameUpp="User"
      @didDeleteItem="didDeleteUser()">
    </Item-delete-modal>

  </div>
</template>

<script>

import B122Table from '../../components/b122/B122Table'
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue";
import i18n from "../../i18n"

export default {

  name: 'UserIndex',

  components: {
    ItemDeleteModal,
    B122Table,
  },

  data () {
    return {

      totalCount: 0,
      allowCreate: this.$store.getters.isAdmin,
      allowDelete: this.$store.getters.isAdmin,
      allowEdit: this.$store.getters.isAdmin,

      ui: {
        selectedUser: null
      }

    }
  },

  computed: {

    tableFields () {
      return [
        {
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('user.Firstname'),
          key: 'firstname',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Lastname'),
          key: 'lastname',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Username'),
          key: 'username',
          sortable: true
        },
        {
          label: this.$i18n.t('Role'),
          key: 'role',
          sortable: false,
          formatter: function (value) {
            return i18n.t(value)
          }
        },
        {
          label: this.$i18n.t('Commission'),
          key: 'commission',
          sortable: false,
          formatter: function (value) {
            return value? value.tostring: '-'
          }
        },
        {
          label: this.$i18n.t('Projects'),
          key: 'nbProjects',
          sortable: false
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }

  },

  methods: {

    setTotalCount (totalCount) {
      this.totalCount = totalCount
    },

    clickOnCreateBtn () {
      this.$router.push({
        name: 'UserCreate'
      })
    },

    clickOnShowBtn (row) {
      this.$router.push({
        name: 'UserShow',
        params: {
          userId: row.item.id
        }
      })
    },

    clickOnEditBtn (row) {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: row.item.id
        }
      })
    },

    clickOnDeleteBtn (row) {
      this.ui.selectedUser = row.item
      this.$bvModal.show('item-delete-modal')
    },

    didDeleteUser () {
      this.ui.selectedUser = null
      this.$refs.B122TableUser.refreshTable()
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserIndex.vue